import { notificationState, NotificationStatus } from 'Utils/notifications'

export const showGenericError = () =>
  notificationState.addNotification({
    title: 'Ocorreu um erro',
    message: 'Por favor, tente novamente mais tarde',
    status: NotificationStatus.ERROR,
  })
